import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PersonCard from '../../../components/PersonCard/PersonCard';
import styles from './tus05organisation.module.css';
import { loadAssignmentsByArea } from '../../../../code/AssignmentPersons';
import { Icons } from '../../../../code/IconHandler';
import * as r from "../../../../config/references_files";
function TuS05Organisation() {
    const navigate = useNavigate();
    const [personsGeschaeftsstelle, setPersonsGeschaeftsstelle] = useState([]);
    const [personsVorstandVorstizende, setVorstandVorstizende] = useState([]);
    const [personsVorstand, setVorstand] = useState([]);
    const [personsBeisitzer, setBeisitzer] = useState([]);
    const [personJugend, setJugend] = useState([]);
    const [personsRedaktion, setRedaktion] = useState([]);
    const color = '--color-red';
    const colorText = '--main-color-white'

    useEffect(() => {
        loadAssignmentsByArea(1, setPersonsGeschaeftsstelle, color, colorText);
        loadAssignmentsByArea(2, setVorstand, color, colorText);
        loadAssignmentsByArea(3, setBeisitzer, color, colorText);
        loadAssignmentsByArea(13, setVorstandVorstizende, color, colorText);
        loadAssignmentsByArea(4, setJugend, color, colorText, true);
        loadAssignmentsByArea(5, setRedaktion, color, colorText);
    }, []);

    const handleGoogleMapsClick = () => {
        window.open("https://maps.app.goo.gl/gimLARdq4RSUUrew7", "_blank");
    };
    return (
        <section className={styles.container}>
            <h1>TuS-Organisation</h1>
            <section className={styles.section}>
                <h2 className={styles.geschaeftsstelle} id='geschaeftsstelle'>Geschäftsstelle</h2>
                <div className={styles.geschaeftsstelle}>
                    <div className={styles.addresContainer}>
                        <div className={styles.address}>
                            <div className={styles.street}>
                                <p><strong>Adresse:</strong><br />Humboldtstraße 3a<br />53639 Königswinter</p>
                                <img
                                    tabIndex={0}
                                    src={`/assets/icons/google-map-icon.png`}
                                    alt="Google Maps Sportplatz"
                                    onClick={handleGoogleMapsClick}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {

                                            e.preventDefault(); // Prevent space from scrolling
                                            handleGoogleMapsClick();
                                        }
                                    }}
                                    style={{ cursor: "pointer" }} />
                            </div>
                            <div className={styles.contact}>
                                <div className={styles.phoneDiv}>
                                    <Icons.Phone />
                                    <p>02244 / 90 20 117</p>
                                </div>
                                <div className={styles.emailDiv}>
                                    <Icons.Mail />
                                    <a href="mailto:geschaeftsstelle@tus05-oberpleis.de" className={styles.email}>
                                        geschaeftsstelle@tus05-oberpleis.de
                                    </a>
                                </div>
                            </div>
                            <div>
                                <table className={styles.date}>
                                    <tr>
                                        <td>Mo - Do:</td>
                                        <td>09:00 - 17:00 Uhr</td>
                                    </tr>
                                    <tr>
                                        <td>Fr:</td>
                                        <td>09:00 - 14:00 Uhr</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className={styles.geschaeftsstelleText}>
                        <p>Wir freuen uns auf ihren Besuch in unserer Geschäftsstelle im Vereinsheim des TuS 05 Oberpleis!</p>
                        <p>Der Eingang der Geschäftsstelle befinder sich in der Straße “Am Krahfeld”. Gehen Sie bitte über den Parkplatz Humboldtstraße Richtung Grundschule und anschließend nach rechts den schmalen Weg “Am Krahfeld” hinunter.
                            Nach ca. 50 m befindet sich die Geschäftsstelle auf der rechten Seite, nutzen Sie bitte den ebenerdigen Eingang unterhalb der Treppe und betätigen Sie zum Öffnen der Tür bitte den Drücker.</p>
                    </div>
                </div>
                <h3 id='ansprechpartner'>Ansprechpartner vor Ort:</h3>
                <div className={styles.ansprechpartner}>
                    {personsGeschaeftsstelle.map((person) => (<PersonCard person={person}></PersonCard>))}
                </div>
            </section>
            <section className={styles.section}>
                <h2 id='vorstand'>Geschäftsführender Vorstand</h2>
                <div className={styles.vorstandMain}>
                    {personsVorstandVorstizende.map((person) => (<PersonCard person={person}></PersonCard>))}
                </div>
                <div className={styles.vorstand}>
                    {personsVorstand.map((person) => (<PersonCard person={person}></PersonCard>))}
                </div>
                <section>
                    <h3>Beisitzer</h3>
                    <div className={styles.beisitzer}>
                        {personsBeisitzer.map((person) => (<PersonCard person={person}></PersonCard>))}
                    </div>
                </section>
            </section>
            <section className={styles.sectionLeitbild}>
                <h2 id='leitbild'>Leitbild des TuS 05 Oberpleis</h2>
                <p><strong>für seine Sportler, Förderer und Freunde</strong></p>
                <div className={styles.leitbildpunkte}>
                    <img className={styles.bgImage} src={`${process.env.PUBLIC_URL}/images/Logo.png`}
                        alt="TuS Logo" />
                    <ul>
                        <li>Für uns als Verein steht der Mensch im Mittelpunkt</li>
                        <li>Nur gemeinsam erreichen wir unsere sportlichen Ziele</li>
                        <li>Die sportliche Zukunft des Vereins können wir nur Zusammen gestalten.Aus- und Weiterbildung in allen sportlichen Bereichen sind eine Investition in die Zukunft des Vereins</li>
                        <li>Als Verein leisten wir einen wichtigen sozialen Beitrag für unsere Sportlerinnern und Sportler</li>
                        <li>Ehrlichkeit, Offenheit und gegenseitige Akzeptanz sind Grundvoraussetzungen für das gemeinsame Miteinander im Verein.</li>
                        <li>Auch bei kritischen Themen sind wir offen gegenüber anderen Meinungen und nehmen Rücksicht auf die Belange der Anderen.</li>
                        <li>Teamfähigkeit, Disziplin, Fairplay und Span an der Sache sind unabdingbar, um die sportlichen Ziele zu erreichen.</li>
                        <li>Vernünftiges und höfliches Auftreten in der Öffentlichkeit in Bekleidung des TuS 05 Oberpleis (Vorbildfunktion) ist die erste positive Visitenkarte des Vereins.</li>
                        <li>Diskriminierung und Gewalt haben beim TuS 05 Oberpleis nichts zu suchen und werden sofort geahndet.</li>
                    </ul>
                </div>
            </section>
            <section className={styles.section}>
                <h2 id='jugendschutz'>Kinder- und Jugendschutz im TuS</h2>
                <div className={styles.jugendschutzkonzept}>
                    <div>
                        {<PersonCard person={personJugend} />}
                        <div tabIndex={0} className={styles.jugendschutzkonzeptButton}
                            onClick={() => window.open(r.jugendschutzkonzept, "_blank")}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {

                                    e.preventDefault(); // Prevent space from scrolling
                                    window.open(r.jugendschutzkonzept, "_blank");
                                }
                            }}
                        >
                            <p>Jugendschutzkonzept</p>
                        </div>
                    </div>
                    <div className={styles.jugendschutzkonzeptText}>
                        <p>Wir sind uns im TuS der großen Verantwortung für die uns anvertrauten Kinder und Jugendlichen bewusst:</p>
                        <p>Sie haben ein Recht auf Schutz vor körperlicher, sexueller und seelischer Gewalt. Wir verschließen unsere Augen nicht, sondern werden stets hinsehen.<br />Da der Kinder- und Jugendschutz im Verein für uns an erster Stelle steht, haben wir ein Konzept entwickelt und Ansprechpartner*innen festgelegt. Das Konzept haben wir hier für Sie hingelegt.</p>
                        <p>Außerdem erarbeiten wir zur Zeit als Träger der Offenen Ganztagsschule in Zusammenarbeit mit der Grundschule am Sonnenhügel ein neues Schutzkonzept, das sich noch stärker an den Bdefürfnissen der Kinder und Jugendlichen orientieren wird.</p>
                        <p>Wenn Sie weitere Fragen haben, melden Sie sich bei uns!</p>
                    </div>
                </div>
            </section>
            <section className={styles.section}>
                <h2 id='oeffentlichkeitsarbeit'>Öffentlichkeitsarbeit</h2>
                <div className={styles.oeffentlichkeitsarbeit}>
                    {personsRedaktion.map((person) => (<PersonCard person={person}></PersonCard>))}
                </div>
                <div className={styles.redaktionsText}>
                    <p>Artikel, Berichte Infos und Medien zur Veröffentlichung bitte an die folgende E-Mail-Adresse senden:</p>
                    <a href="mailto:redaktion@tus05-oberpleis.de" className={styles.email}>
                        redaktion@tus05-oberpleis.de
                    </a>
                </div>
            </section>
            <section className={styles.section}>
                <h2 id='satzung-und-mitgliederversammlung'>Satzung und Mitgliederversammlung</h2>
                <div className={styles.satzung}>
                    <p>Unsere Satzung ist hier zu finden: <span tabIndex={0} onClick={() => navigate('/service#satzung-beschluss-20200928')}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {

                                e.preventDefault(); // Prevent space from scrolling
                                navigate('/service#satzung-beschluss-20200928')
                            }
                        }}
                    >Satzung</span></p>
                    <p>Hier findet ihr die Einladung zur nächsten Mitgliederversammlung: <span tabIndex={0} onClick={() => navigate('/service#einladung-zur-mitgliederversammlung')}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {

                                e.preventDefault(); // Prevent space from scrolling
                                navigate('/service#einladung-zur-mitgliederversammlung')
                            }
                        }}
                    >Einladung</span></p>
                    <p>Hier findet ihr die Protokolle der letzten Mitgliederversammlungen: <span tabIndex={0} onClick={() => navigate('/service#protokoll-mitgliederversammlung-20230613')}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {

                                e.preventDefault(); // Prevent space from scrolling
                                navigate('/service#protokoll-mitgliederversammlung-20230613')
                            }
                        }}
                    >Protokolle</span></p>
                </div>
            </section>

        </section>
    );
}
export default TuS05Organisation;